import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";

const NAV_LINKS = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/portfolio", label: "Portfolio" },
  { href: "/journey", label: "Journey" },
];

export const Header = () => {
  const currentPath = window.location.pathname;

  return (
    <div
      className="
        fixed md:absolute z-20
        top-0 md:top-6
        left-0 md:left-6
        right-0 md:right-auto
        w-full md:w-60
        rounded-none md:rounded-3xl
        bg-[#EEF2FF]/25 backdrop-blur-[30px]
        border-b md:border border-[#E7E7E7]/50
        shadow-[0_8px_32px_rgba(61,44,141,0.06)]
        px-4 py-4 md:px-4 md:py-8
        flex flex-row md:flex-col
        justify-between md:justify-between
        items-center md:items-stretch
        md:h-[calc(100vh-3rem)]
      "
    >
      <nav className="flex flex-row md:flex-col gap-2 md:gap-2 w-full md:flex-1 md:justify-center p-2 md:p-3">
        {NAV_LINKS.map((link) => {
          const isActive = currentPath === link.href;

          return (
            <a
              key={link.href}
              href={link.href}
              className={`
                px-4 py-2.5 rounded-2xl text-sm md:text-lg font-medium transition-all duration-300
                ${isActive
                  ? "bg-[#EEF2FF]/40 backdrop-blur-[30px] border border-[#E7E7E7]/50 shadow-sm text-ink"
                  : "text-muted hover:bg-white/15 hover:text-ink"
                }
              `}
            >
              {link.label}
            </a>
          );
        })}
      </nav>

      <div className="hidden md:flex flex-col items-center text-center gap-4 pt-6 mt-auto border-t border-[#4C4B7E]/30">
        <p className="text-sm text-muted">@2026 Eden C. Louis Portfolio</p>

        <div className="flex gap-3">
          <a
            href="https://github.com/Ed-Ls"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted hover:text-ink transition-colors"
            aria-label="GitHub"
          >
            <FontAwesomeIcon icon={faGithub} className="text-2xl" />
          </a>
          <a
            href="https://www.linkedin.com/in/e-c-ls/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted hover:text-ink transition-colors"
            aria-label="LinkedIn"
          >
            <FontAwesomeIcon icon={faLinkedin} className="text-2xl" />
          </a>
        </div>

        <a href="/legal" className="text-sm text-muted hover:text-ink transition-colors">
          See the legal notice
        </a>
      </div>
    </div>
  );
};
